"use client";

import { Col, Row } from "antd";
import { FC, useRef } from "react";
import { useIsDesktop } from "@/hooks/app/useIsDesktop";
import { useTERouter } from "@/hooks/app/useTERouter";
// import { useEsimCatalogFilters } from "@/hooks/esim/useEsimCatalogFilters"; // chỉ dùng cho SelectEsimFilter (data/validity) — đã ẩn, xem comment dưới
// import { useAppDispatch } from "@/lib/redux/hooks"; // chỉ dùng để gọi /esim/countries, tạm tắt
// import { thunks } from "@/lib/redux/thunks"; // tạm tắt /esim/countries, dự tính thay bằng thư viện mã quốc gia
// import { buildEsimSearchBody } from "@/utils/esim/buildEsimSearchBody"; // chỉ dùng để gọi /esim/countries, tạm tắt
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import SelectCountry from "./SelectCountry";
// import SelectCountryCode from "./SelectCountryCode"; // đã ẩn theo yêu cầu — chỉ giữ lại "Tìm kiếm eSIM"
// import SelectEsimFilter from "./SelectEsimFilter"; // đã ẩn theo yêu cầu — chỉ giữ lại "Tìm kiếm eSIM"
import ButtonSearch from "./ButtonSearch";

type FormSearchEsimProps = {
  size?: "default" | "small";
  /** Điền sẵn theo điều kiện đang xem — dùng ở trang kết quả tìm kiếm để đổi lại. */
  initialQuery?: string;
  // initialCountryCode/initialData/initialValidity — hết tác dụng từ khi ẩn SelectCountryCode/SelectEsimFilter,
  // không còn caller nào truyền vào, giữ comment phòng khi cần bật lại các field này.
  // initialCountryCode?: string;
  // initialData?: string;
  // initialValidity?: string;
  /** Không còn phân biệt gì nữa (mọi nơi đều chỉ còn "Tìm kiếm eSIM") — giữ lại prop để khỏi phải sửa
   * chỗ gọi cũ (`EsimSearchResultsPageClient`), không có tác dụng thực tế. */
  hideFilters?: boolean;
};

const FormSearchEsim: FC<FormSearchEsimProps> = ({ size = "default", initialQuery }) => {
  const isDesktop = useIsDesktop();
  // const dispatch = useAppDispatch(); // chỉ dùng để gọi /esim/countries, tạm tắt
  const router = useTERouter();
  const { t } = useTranslation();
  const isSmall = size === "small";
  const queryRef = useRef(initialQuery ?? "");
  // const countryCodeRef = useRef<string | null>(initialCountryCode ?? null); // SelectCountryCode đã ẩn
  // const [dataFilter, setDataFilter] = useState<string | null>(initialData ?? null); // SelectEsimFilter đã ẩn
  // const [validityFilter, setValidityFilter] = useState<string | null>(initialValidity ?? null); // SelectEsimFilter đã ẩn
  // const { dataOptions, validityOptions, loading: filtersLoading } = useEsimCatalogFilters(); // SelectEsimFilter đã ẩn

  // Tạm tắt /esim/countries — dự tính thay bằng thư viện mã quốc gia.
  // useEffect(() => {
  //   dispatch(
  //     thunks.esim_countries({
  //       body: {
  //         TYPE: "JSON",
  //         ...buildEsimSearchBody(),
  //       },
  //     }),
  //   );
  // }, [dispatch]);

  // Đổi tên từ handleSearchOnly — giờ dùng chung mọi nơi (không còn field quốc gia/dung lượng/thời hạn
  // để phân biệt). Chỉ đổi `search` trên URL, giữ nguyên các param khác đang có (vd countriesAny/data/
  // validity do sidebar trang kết quả quản lý) — không tự tạo params từ đầu để tránh ghi đè chúng.
  // Không có param nào sau khi build (kể cả search) thì coi là "chưa nhập gì", báo lỗi thay vì điều
  // hướng tới trang kết quả trống.
  const handleSearch = () => {
    const query = queryRef.current.trim();
    const params = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "");
    if (query) params.set("search", query);
    else params.delete("search");
    if (![...params.keys()].length) {
      toast.error(t("esim.search_required"));
      return;
    }
    router.push(`/esim-du-lich/ket-qua-tim-kiem?${params.toString()}`);
  };

  // Compact bar (home tab) — chỉ còn "Tìm kiếm eSIM" + nút tìm, giữ style bar cho khớp widget tab trang chủ.
  if (isSmall) {
    return (
      <Row
        wrap={!isDesktop}
        gutter={isDesktop ? [0, 0] : [10, 10]}
        align="stretch"
        className={
          isDesktop
            ? "home__searching--tour-search-row home__searching--tour-search-row--bar"
            : undefined
        }
        style={{ marginBlock: isDesktop ? 0 : "2rem" }}
      >
        <Col
          flex={isDesktop ? "1 1 auto" : undefined}
          span={isDesktop ? undefined : 24}
          className={isDesktop ? "home__searching--tour-search-cell" : undefined}
        >
          <SelectCountry
            initialQuery={initialQuery}
            onQueryChange={(value) => (queryRef.current = value)}
            onPressEnter={handleSearch}
          />
        </Col>
        <Col
          flex={isDesktop ? "none" : undefined}
          span={isDesktop ? undefined : 24}
          className={
            isDesktop ? "home__searching--tour-search-cell home__searching--tour-search-cell--btn" : undefined
          }
        >
          <ButtonSearch compact={isDesktop} onClick={handleSearch} />
        </Col>
      </Row>
    );
  }

  // Hub page + trang kết quả tìm kiếm (mobile lẫn desktop) — chỉ còn "Tìm kiếm eSIM" + nút tìm.
  return (
    <Row gutter={[10, 10]} align="middle" className="esim-hub__search-bar" style={{ marginBlock: "2rem" }}>
      <Col xs={24} md={21}>
        <SelectCountry
          initialQuery={initialQuery}
          onQueryChange={(value) => (queryRef.current = value)}
          onPressEnter={handleSearch}
        />
      </Col>
      <Col xs={24} md={3}>
        <ButtonSearch fullWidth onClick={handleSearch} />
      </Col>
    </Row>
  );
};

export default FormSearchEsim;
